export default __webpack_public_path__ + "static/user-d720da644f90340999d5c6a8fdfb8d6e.svg";